import { call, put, takeEvery } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { domainService } from "@/services/domainService";
import { CreateDomainDto, UpdateDomainDto } from "@/types/models/domain";
import { toApiError } from "@/lib/errorHelpers";
import {
  fetchDomainsRequest,
  fetchDomainsSuccess,
  fetchDomainsFailure,
  createDomainRequest,
  createDomainSuccess,
  createDomainFailure,
  updateDomainRequest,
  updateDomainSuccess,
  updateDomainFailure,
  deleteDomainRequest,
  deleteDomainSuccess,
  deleteDomainFailure,
} from "@/store/slices/domain.slice";

function* fetchDomainsSaga(
  action: PayloadAction<{ page?: number; limit?: number }>,
): Generator<any, void, any> {
  try {
    const response: any = yield call(domainService.getDomains, action.payload);

    yield put(
      fetchDomainsSuccess({
        data: response.data || response,
        pagination: response.pagination || {
          page: action.payload.page || 1,
          totalPages: 1,
          pageSize: action.payload.limit || 10,
          total: response.data?.length || response.length || 0,
        },
      }),
    );
  } catch (error: any) {
    yield put(fetchDomainsFailure(toApiError(error)));
  }
}

function* createDomainSaga(
  action: PayloadAction<CreateDomainDto>,
): Generator<any, void, any> {
  try {
    const response: any = yield call(
      domainService.createDomain,
      action.payload,
    );

    yield put(createDomainSuccess(response.data || response));
  } catch (error: any) {
    yield put(createDomainFailure(toApiError(error)));
  }
}

function* updateDomainSaga(
  action: PayloadAction<{ id: string; data: UpdateDomainDto }>,
): Generator<any, void, any> {
  try {
    const response: any = yield call(
      domainService.updateDomain,
      action.payload.id,
      action.payload.data,
    );

    yield put(updateDomainSuccess(response.data || response));
  } catch (error: any) {
    yield put(updateDomainFailure(toApiError(error)));
  }
}

function* deleteDomainSaga(
  action: PayloadAction<{ id: string }>,
): Generator<any, void, any> {
  try {
    yield call(domainService.deleteDomain, action.payload.id);

    yield put(deleteDomainSuccess({ id: action.payload.id }));
  } catch (error: any) {
    yield put(deleteDomainFailure(toApiError(error)));
  }
}

export function* domainSaga(): Generator<any, void, any> {
  yield takeEvery(fetchDomainsRequest.type, fetchDomainsSaga);
  yield takeEvery(createDomainRequest.type, createDomainSaga);
  yield takeEvery(updateDomainRequest.type, updateDomainSaga);
  yield takeEvery(deleteDomainRequest.type, deleteDomainSaga);
}
